module.exports = __webpack_public_path__ + "img/renyuan.d6bdff23.svg";